export default {"src":"/_next/static/media/brand-checkmark.8b0023c7.svg","height":9,"width":10,"blurWidth":0,"blurHeight":0};